<template>
  <div :class="[classes(n('--content')), classes(n(`--content--confirm`))]">
    <div
      v-for="(chunkedSetting, i) in data"
      :key="i"
      :class="classes(n(`--content--confirm--column${i}`))"
    >
      <div
        v-for="(keysSetting, j) in chunkedSetting"
        :key="`keyboard-column-${j}`"
        :class="[classes(n(`--content--confirm--item`)),classes(n(`--content--confirm--column${i}--item`))]"
      >
        <div
          v-for="item in keysSetting"
          :key="item.key"
          :class="[n(`--content--confirm--item--split`),n(`--content--confirm--column${i}--item--split`),item.className ? n(`--content--confirm--column${i}--item--${item.className}`) : '']"
        >
          <KeyboardItem
            :class="getItemClassList(item)"
            :value="item.key"
            :safe-mode="safeMode"
            :confirm-btn-text="confirmBtnText"
            :confirm-btn-enable="confirmBtnEnable"
            @click="handleClick"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from 'virtual-vue';
import { createNamespace } from '../../utils/components';
import { getConfirmKeyboardSetting, splitKeyboardKeys } from '../business';
import KeyboardItem from './keyboard-item.vue';
import { props } from '../props';
import { KeyboardEmitsEvent } from '../emits';
import { KeyboardKeySetting, KeyboardKeyType } from '../keyboard';


const { name, n, classes } = createNamespace('keyboard');

/**
 * 普通键盘布局展示
 * @description 默认普通键盘.
 */
export default defineComponent({
  name: `${name}-confirm`,
  components: { KeyboardItem },
  props,
  emits: ['click'],
  setup(props, { emit }) {
    const setting = getConfirmKeyboardSetting(props.decimal);
    const data = reactive(setting.map(item => splitKeyboardKeys(item)));

    function getItemClassList(item: KeyboardKeySetting) {
      const classList: string[] = [n('--content--confirm--item--key')];
      if (item.className) {
        classList.push(n(`--content--item--${item.className}`));
        if (item.key === KeyboardKeyType.Confirm && !props.confirmBtnEnable) {
          classList.push(n(`--content--item--${item.className}-disabled`));
        }
      }
      return classList;
    }

    /**
     * 点击键盘触发事件
     * @param options 参数
     */
    function handleClick(options: { type: KeyboardEmitsEvent, value?: string }) {
      emit('click', options);
    }

    return {
      n,
      classes,
      data,
      getItemClassList,
      handleClick,
    };
  },
});
</script>
